import { useMutation, useQueryClient } from "react-query";
import { deleteEmployeeExpectations } from "~/pages/Editor/EditorStaff/requests/DeleteEmployeeExpectations/getDataExpectations";

export default function useDeleteEmployeeExpectations() {
  const queryClient = useQueryClient();

  return useMutation(deleteEmployeeExpectations, {
    onSuccess: () => {
      queryClient.invalidateQueries(["getDataStaffBonus"]);
    },
  });
}
